export default "__VITE_ASSET__C8L45NWS__"